module.exports = __webpack_public_path__ + "static/media/sacramento-matromonio-santuario.388f34d1.jpg";